import { c as _c } from "react/compiler-runtime";
import { touchWeightAnalyzerRequirementsSymbol, type TouchWeightAnalyzerRequirements } from '@/lib/piano/touch-design/touch-weight-analyzer/touch-weight-analyzer-requirements';
import { useMeasuredKey } from './use-measured-key';
import { useInjection } from 'inversify-react';
import type { TouchWeightKeyAnalysis } from '@/lib/piano/touch-design/touch-weight-key-analysis';
import { useMemo } from 'react';
export const useAnalyzedKey = keyNumber => {
  const $ = _c(5);
  const {
    measuredKey
  } = useMeasuredKey(keyNumber);
  const touchWeightAnalyzer = useInjection(touchWeightAnalyzerRequirementsSymbol);
  let t0;
  bb0: {
    if (measuredKey !== undefined) {
      let t1;
      if ($[0] !== measuredKey || $[1] !== touchWeightAnalyzer) {
        t1 = touchWeightAnalyzer.analyzeKey(measuredKey);
        $[0] = measuredKey;
        $[1] = touchWeightAnalyzer;
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      t0 = t1;
      break bb0;
    }
    t0 = undefined;
  }
  const analyzedKey = t0;
  let t1;
  if ($[3] !== analyzedKey) {
    t1 = {
      analyzedKey
    };
    $[3] = analyzedKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};